module.exports = __webpack_public_path__ + "00@2x.png?008ca2ccdd7cb7ac65dd2af1f5bf06c8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/00@2x.png
// module id = 76
// module chunks = 0